module Meevo.Plugins.MeevoBi {
    "use strict";

    /**
    * Main Section of MeevoBI
    */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)
            this.dataService.customMethodData("/api/tenant/businessinfo/meevourl", "GET", null).then((data) => {
                this.model = data.data;
            });
        }

        public activate(): void {
            super.activate();
        }
    }
}